// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19q-c","icon":"styles_icon__27_nV"};